/* eslint-disable no-console */
<template>
    <div class="main_unit">
        <div class="store_login_unit">{{brandStoreName}}</div>
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div class="staff_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue" v-show="!isInitLoading">

            <div class="error_text">
                <label class="lavel_error_font">{{ApivalidationMessage}}</label><br>
            </div>

            <div class="admin_menu_top_unit staff_new_button">
                <div class="staff_buttan_unit">
                    <div class="staff_kanri_box">
                        <ul><li>
                            <router-link class="staff_buttan_unit top_tit" :to="{ name: 'manageStaffAdd'} ">新規登録</router-link>
                        </li></ul>
                    </div>
                </div>
            </div>
            <table>
                <tbody>
                <tr class="text-center">
                    <th class="wd400 border_bottom_none" v-for="(value,key) in columns" :key="key" @click="sortBy(key)">
                        氏名
                        <img class="triangle" v-if="sortOrders[key] > 0" src="../assets/img/UnderTriangleWhite.png" width="15px" height="13px" alt="UnderTriangle">
                        <img class="triangle" v-if="sortOrders[key] <= 0" src="../assets/img/UpTriangleWhite.png" width="15px" height="13px" alt="UpTriangle">
                    </th>
                    <th class="wd310" rowspan="2">編集 / 削除</th>
                </tr>
                <tr>
                    <th class="border_top_none"><input class="wd200" type="text" v-model="searchWord" placeholder="キーワード検索"> </th>
                </tr>
                <tr v-for="staff in filteredDatas" v-bind:key="staff.staffId">
                    <td class="text_white_space" v-for="(value,key) in columns" :key="key">
                        {{staff.staffName}}
                    </td>
                    <td class="staff_buttan_unit staff_kanri_box staff_kanri_button">
                        <ul class="ul_tbl_buttan">
                            <li><router-link class="staff_buttan_unit" :to="{ name: 'manageStaffEdit' ,params:{id:staff.id}} ">編集</router-link></li>
                            <li><a class="staff_buttan_unit " href="#" @click.prevent.stop="openModel(staff.id,staff.staffId,staff.staffName)">削除</a></li>
                        </ul>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">スタッフ削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>このスタッフを削除しますか？<br>
                            氏名：{{this.delStaffName}}
                        </p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a href="#" @click.prevent.stop="closeModel">キャンセル</a>
                        </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="delModel">削除</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">スタッフ削除</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>スタッフ削除が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel2">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
export default {
    name: 'staffListData',
    components: {
        PulseLoader,
    },
    data: function () {
        var columns = {
            staffNameFurigana :"ふりがな",
        };
        var sortOrders = {};
        Object.keys(columns).forEach(function (key) {
            sortOrders[key] = 1
        });
        return {
            ApivalidationMessage:'',
            isLoading:false,
            isInitLoading:true,
            brandId: '',
            storeId: '',
            columns:columns,
            sortKey:'',
            sortOrders:sortOrders,
            searchWord:'',
            delId:null,
            delStaffName:"",
            showContent:false,
            showContent2:false,
            staffList: []
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        filteredDatas: function () {
            var data = this.staffList;
            var sortKey = this.sortKey;
            var order = this.sortOrders[sortKey] || 1;

            if (sortKey) {
                data = data.slice().sort(function (a, b) {
                    a = a[sortKey];
                    b = b[sortKey];
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                });
            }

            var filterWord = this.searchWord && this.searchWord.toLowerCase();
            if (filterWord) {
                data = data.filter(function (row) {
                    return Object.keys(row).some(function () {
                        return String(row["staffName"]).toLowerCase().indexOf(filterWord) > -1
                    })
                })
            }
            return data;
        },
        brandStoreName: function () {
            let brandName = this.$store.getters['brand/name']
            let storeName = this.$store.getters['store/name']

            if (brandName == null) {
                brandName = ''
            }

            if (storeName == null) {
                storeName = ''
            }

            return brandName + '・' + storeName
        },
    },
    created: function(){
        this.calc();
    },
    methods: {

        calc:async function(){
            // 企業ブランドIDの取得
            this.brandId = this.$store.getters['brand/id']
            // 店舗IDの取得
            this.storeId = this.$store.getters['store/id']

            // DBデータ取得
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/staff')
                .then(response => (this.staffList = response['data']['staffList']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}

                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }

                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

        },
        sortBy:function(key){
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;

        },
        openModel(id,staffid, staffnama) {
            this.showContent = true;
            this.delId = id;
            this.delStaffName = staffnama;
        },
        closeModel() {
            this.showContent = false;
            this.delId = null,
            this.delStaffName = "";
        },
        async delModel() {

            this.ApivalidationMessage = '';
            this.showContent = false;
            this.isLoading = true;

            var apiResponseFlg = true;

            // DBデータ取得
            await this.$axios
                .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/store/' + this.storeId + '/staff/' + this.delId + '/delete')
                .then(response => (this.staffList = response['data']['staffList']))
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);
                        if(error.code == 400){
                            this.ApivalidationMessage =  error.message;
                        } else if (error.code == 401) {
                            //店舗管理者のtokenエラーの場合
                            this.$cookies.set('user-api-token', '', 0)
                            this.$store.dispatch('store/doClear')
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            if(apiResponseFlg){
                this.showContent2 = true;
                this.calc();
            }

        },
        closeModel2() {
            this.showContent2 = false;
            this.delId = null,
            this.delStaffId = "";
            this.delStaffName = "";
        }
    }
}
</script>